import { NullableString } from '../util/types';

export enum OrderSideEnum {
  Buy = 'Buy',
  Sell = 'Sell',
  // TODO: Update (remove) this type if not to be used with SOR
  /**
   * Initially not supported by SOR
   */
  SellShort = 'SellShort',
}

export const isValidOrderSideEnumStatus = (
  value: NullableString,
): boolean => Object.values(OrderSideEnum).includes(value as OrderSideEnum);
